import { message } from 'antd'
import { isNil } from 'lodash'

export const isDimensionsValid = (
  title: string,
  shouldArrRequireValue: boolean,
  arr?: ({ [index: string]: number } | undefined)[]
) => {
  if (shouldArrRequireValue && (!arr || arr.length === 0)) {
    const error = `${title}需要至少添加一项`
    message.error(error)
    return false
  }

  if (!arr || arr.length === 0) {
    return true
  }

  const isItemValid = arr.every((i) => !isNil(i))
  if (!isItemValid) {
    const error = `${title}已添加项需有数值`
    message.error(error)
    return false
  }

  const isItemOverZero = arr.every((i) => Object.values(i!)[0] > 0)
  if (!isItemOverZero) {
    const error = `${title}已添加项数值需大于 0`
    message.error(error)
    return false
  }

  const total = arr.reduce((prev, curr) => {
    return (Number(prev) + Number(Object.values(curr!)[0])).toFixed(1)
  }, '0')
  const expect = Number(100).toFixed(1)
  const isTotalOneHundred = total === expect

  if (!isTotalOneHundred) {
    const error = `${title}已添加项数值之和需为100%`
    message.error(error)
    return false
  }

  return true
}
